import { find } from 'lodash';

const populateForm = (dbData, formTemplate) => {
  let templateCopy = JSON.parse(JSON.stringify(formTemplate));

  Object.keys(dbData).map((field, index) => {
    if (dbData[field] === null) dbData[field] = '';
    if (templateCopy[field] && dbData[field] !== '') {
      templateCopy[field].value = dbData[field]
      templateCopy[field].touched = true;
      if (templateCopy[field].breed === 'select') {
        let selectedOption = find(templateCopy[field].options, { 'value': dbData[field] });
        templateCopy[field].displayValue = selectedOption.name;
      }
    } else if (templateCopy[field]) {
      templateCopy[field].value = dbData[field]
    }
  })
  return templateCopy;
}

export default populateForm;



/** WEBPACK FOOTER **
 ** ./src/helpers/PopulateForm.js
 **/